import {
  COMPONENT_LOAD_ERROR,
  ROUTE_ERROR_APP_LOAD_FAILED_NAME,
} from "../../../constants";
import {
  EErrorType,
  type ErrorService,
  type IApiError,
} from "draivn-ui-domain";
import { useSystemStore } from "../../store";
import { injector } from "@/services";
import { ROUTER_SERVICE_INJECTION_KEY } from "@/constants";

export const componentLoadDisplayHandlerInit = (errorService: ErrorService) => {
  const router = injector.injectFromRoot(ROUTER_SERVICE_INJECTION_KEY);

  const componentLoadErrorDisplayHandler = (error: IApiError) => {
    const isComponentLoadError =
      (error.data[0] as Error).message === COMPONENT_LOAD_ERROR;
    if (isComponentLoadError) {
      errorService.blockDisplay();
      const $systemStore = useSystemStore();
      $systemStore.stopHealthCheck();

      if (router.currentRoute.value.name !== ROUTE_ERROR_APP_LOAD_FAILED_NAME) {
        void router.push({ name: ROUTE_ERROR_APP_LOAD_FAILED_NAME });
      }
    }
  };

  errorService.registerErrorDisplay(EErrorType.LOCAL, {
    display: componentLoadErrorDisplayHandler,
  });
};
